<template>
  <div
    class="tab-pane fade active show"
    id="searchControl-content"
    role="tabpanel"
    aria-labelledby="searchControl-tab"
  >
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-4">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="">請選擇</option>
            <option value="-1">全部</option>
            <option
              v-for="(list, index) in weatherAreas"
              :key="index"
              :value="list.id"
            >
              {{ list.name }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="startTime"
            @focus="updateMaxSelectTime"
          >
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="endTime"
            @focus="updateMaxSelectTime"
          >
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button
            type="button"
            class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1"
            @click="query"
            :disabled="isWaitResult"
          >
            <i class="fas fa-search"></i> 查詢
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm rounded-pill px-3 mx-1"
            @click="queryCSV"
            :disabled="isWaitResult"
          >
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px">事件查詢</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">
              <table id="searchControlTable" :class="tableStyle">
                <thead class="table-dark">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">風景區</th>
                    <th scope="col">開始時間</th>
                    <th scope="col">開啟帳號</th>
                    <th scope="col">結束時間</th>
                    <th scope="col">結束帳號</th>
                    <th scope="col">通報事件</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, key) in dataTableList"
                    :key="key"
                    :class="tableCenterStyle"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>{{ item.scenicAreaName }}</td>
                    <td>{{ getTime(item.controlStartTime) }}</td>
                    <td>{{ item.controlStartUser }}</td>
                    <td>{{ getTime(item.controlEndTime) }}</td>
                    <td>{{ item.controlEndUser }}</td>
                    <td>
                      <button
                        class="btn btn-info"
                        @click="
                          openModal(
                            item.scenicAreaId,
                            item.controlStartTime,
                            item.controlEndTime
                          )
                        "
                      >
                        查看
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" ref="disasterModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title h5">通報事件列表</div>
          </div>
          <div class="modal-body">
            <div class="bd-example">
              <table id="disasterTable" :class="tableStyle">
                <thead class="table-dark">
                  <tr>
                    <th scope="col">通報時間</th>
                    <th scope="col">警示項目</th>
                    <th scope="col">通報內容</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in disasterTableList" :key="index">
                    <td>{{ getTime(item.eventTime) }}</td>
                    <td>{{ getEvent(item) }}</td>
                    <td>{{ item.content }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import exportCSV from "../../utils/exportCSV";
import { getControlHistoryByTimeInterval } from "../../api/eastCoastDataApi/scenicPlace/ControlHistoryApi";
export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      startTime: moment().startOf("day").format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: "",
      dataTableList: [],
      disasterTableList: [],
      isWaitResult: false,
      modalData: {},
      typeList: [],
      maxSelectTime: Utils.getLastestTime(),
    };
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),

    // maxSelectTime() {
    //   return moment().startOf("m").toISOString();
    // },
    weatherAreas() {
      return this.scenicAreaList.filter(
        (item) =>
          item.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CLOSE_IN_ADVANCE
      );
    },
  },
  watch: {},
  methods: {
    async queryCSV() {
      const allDatas = await this.searchElk();

      const csvContent = [
        ["風景區", "開始時間", "開啟帳號", "結束時間", "結束帳號"],
      ];

      allDatas.forEach((item) => {
        const row = [];
        row.push(item.scenicAreaName);
        row.push(this.getTime(item.controlStartTime));
        row.push(item.controlStartUser);
        row.push(this.getTime(item.controlEndTime));
        row.push(item.controlEndUser);

        csvContent.push(row);
      });

      const fileName = `景區管制_${moment(this.startTime).format(
        "YYYY/MM/DD HH:mm"
      )}.csv`;
      exportCSV.genCSVFile(csvContent, fileName);
    },

    async query() {
      this.isWaitResult = true;
      this.dataTableList = await this.searchElk();
      this.updateTable();
      this.isWaitResult = false;
    },

    async searchElk() {
      if (
        Utils.isEmptyObject(this.startTime) ||
        Utils.isEmptyObject(this.endTime)
      ) {
        alert("請選擇起訖時間");
        return;
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert("結束時間不可以小於開始時間");
        return;
      }

      if(this.selectScenicAreaId ===""){
        alert("請選擇風景區");
        return;
      }

      let condition = {
        startTime: moment(this.startTime).startOf('minute').format(),
        endTime: moment(this.endTime).startOf('minute').format(),
        // startTime: "2022-10-12T15:16:56",
        // endTime: "2022-10-13T23:10:42",
        scenicAreaId:this.selectScenicAreaId,
      };

      if(this.selectScenicAreaId === -1){
        const areaId=  this.weatherAreas.map((s) => s.id);
        // console.log("area",areaId)
        condition.scenicAreaId = areaId;
        // console.log("condition.areas",condition.areas);
        }
      
      let allDatas = []
      const result = await getControlHistoryByTimeInterval(condition);
      allDatas = result.success ? result.data : []
      return allDatas
    },

    async openModal(areaid, startTime, endtime) {
      const condition = {
        startTime: startTime,
        endTime: endtime,
        id: areaid,
      };
      console.log(condition);
      let disasters = [];
      await this.$store.dispatch("disasterMonitor/getAreaDisaster", condition);
      disasters = this.$store.getters["disasterMonitor/getDisaster"];
      //console.log(disasters);
      this.disasterTableList = disasters;
      $(this.$refs.disasterModal).modal("show");
    },
    getTime: function (time) {
      if (Utils.isEmptyObject(time)) {
        return "-";
      }

      return moment(time).format("YYYY/MM/DD HH:mm");
    },

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },
    getEvent(item) {
      const target = this.typeList.find(
        (type) => (type.enumType)=== item.conditionType
      );
      return target
        ? target.description === '豪雨' ? '豪雨' : item.magnitudeValue + target.unit
        : "";
    },

    initTable: function () {
      this.table = $("#searchControlTable").DataTable({
        aoColumns: [
          ...new Array($("#searchControlTable th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url: "/json/dataTableZHTW.json",
        },
        pageLength: 25,
      });
    },
    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy();
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
  },
  mounted() {
    this.typeList = Object.values(CONST.CLIMATE_TYPE_ENUM);
    this.typeList.shift(); // 移除unknow
    this.updateTable();
  },
};
</script>
<style scoped>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

select:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

tbody>tr>td, tr > th {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}

/* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
}

/* table不超過div */
</style>
